import { createSelector } from 'reselect';
import { BOUQUET_MY_EXCO, EXCO_SERVICES } from 'const/excoServices';

export const selectPackagesInCart = (state) =>
  state.cartReducer?.currentItems || [];

export const selectPackagesCosts = (state) =>
  state.cartReducer?.packagesCosts || {};

export const selectPackagesCostsStatus = (state) =>
  state.cartReducer?.packagesCostsStatus;

export const selectPackagesInCartWithCost = createSelector(
  [selectPackagesInCart, selectPackagesCosts],
  (packagesNames, packagesCosts) =>
    packagesNames.map((packageName, index) => ({
      name: packageName,
      cost: packagesCosts[packageName] || 'N/A',
      id: index + 1,
    }))
);

export const selectCardsWithCost = createSelector(
  [selectPackagesCosts],
  (packagesCosts) =>
    EXCO_SERVICES.map((service) => ({
      ...service,
      PACKAGE_COST: packagesCosts[service.PACKAGE_NAME] || null,
    }))
);

export const selectMyExcoPackageWithCost = createSelector(
  [selectPackagesCosts],
  (packagesCosts) => ({
    ...BOUQUET_MY_EXCO,
    PACKAGE_COST: packagesCosts[BOUQUET_MY_EXCO.PACKAGE_NAME] || null,
  })
);

export const selectSubscriptionStatus = (state) => state.cartReducer?.status;

export const selectShouldCartBeReseted = (state) =>
  state.cartReducer?.shouldBeReseted;
